import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
// import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { isEmailValid } from '../../functions/isEmailValid';
import { setCaptchaHeader } from '../../actions/index';
import { NativeDropdown } from '../NativeDropdown/NativeDropdown';
import { HoverTip } from '../HoverTip/HoverTip';

import { Button, Grid, Box, Typography, TextInput, Tooltip, Text, ButtonIcon, Textarea, Modal, Field, FieldLabel } from '@blueprint/ui';
import { LabelBox } from '../Box/LabelBox';
import { TextInputBox } from '../Box/TextInputBox';
import { axiosInstance } from '../../functions/axios';
import { InlineNotificationComponent } from '../Notification/InlineNotificationComponent';
import CONSTANTS from '../../constants/constants';

import ReCaptcha from '../Recaptcha/Recaptcha';

const StyledDiv = styled.div`
    padding-top: 100px;
    padding-left: 5vw;
    padding-right: 5vw;
    padding-bottom: 5em;
`;

const ContactUs = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    console.log('Data passed by previous component is ', location.state);
    const [previousPath, setPreviousPath] = useState(location?.state?.previousUrl ? location?.state?.previousUrl : '/');
    const [wasLogged, setWasLogged] = useState(location?.state?.wasLogged);
    const globalState = useSelector((state) => state);
    const BANK_DETAILS = process.env.REACT_APP_BANK_DETAILS;
    const VERIFY_DETAILS_CONFIRM = process.env.REACT_APP_VERIFY_DETAILS_CONFIRM;
    const ACKNOWLEDGEMENT = process.env.REACT_APP_ACKNOWLEDGEMENT;
    const REGISTRATION_STEP_2 = process.env.REACT_APP_REGISTRATION_STEP_2;
    const SUBMIT_CONTACT_US = process.env.REACT_APP_SUBMIT_CONTACT_US;

    var CAPTCHA_ENABLED;
    if (process.env.NODE_ENV === 'development') {
        console.log('ENV is DEV hence using ENABLE value from constants');
        CAPTCHA_ENABLED = CONSTANTS.CAPTCHA_ENABLED;
    } else {
        console.log('ENV is not dev hence using ENABLE value from redux');
        CAPTCHA_ENABLED = globalState.beneDetails.captchaConfig.recaptchaEnabled;
    }

    console.log(`Logging CAPTCHA_ENABLED ${CAPTCHA_ENABLED}`);
    console.log(`Logging typeof CAPTCHA_ENABLED ${typeof CAPTCHA_ENABLED}`);

    const { t } = useTranslation();
    const [hover, setHover] = useState(false);
    const [userCaptcha, setUserCaptcha] = useState('');
    const [modalText, setModalText] = useState(t('contactUs.yourRequestHasBeenSubmitted'));
    const [open, setOpen] = useState(false);
    const [captchaValidationError, setCaptchaValidationError] = useState(false);
    const [captcha, setCaptcha] = useState(null);

    const userCaptchaInput = (event) => {
        setUserCaptcha(event.value);
    };

    const beneDetails = useSelector((state) => state.beneDetails);
    const footerHeight = globalState.beneDetails.footerHeight;

    useEffect(() => {
        if (wasLogged) {
            if (!globalState.beneDetails.details.isLogged) {
                history.push('/');
            }
        }
    }, [globalState, history]);

    const sendUserBack = () => {
        console.log(`Trying switch case with ${previousPath}`);

        switch (previousPath) {
            case BANK_DETAILS:
                console.log(`Pushing to ${BANK_DETAILS}`);
                dispatch(setCaptchaHeader(null));
                history.push({
                    pathname: BANK_DETAILS,
                    state: {
                        custId: beneDetails.paymentDetails.custId,
                        tnxIds: beneDetails.paymentDetails.tnxIds,
                    },
                });
                break;
            case VERIFY_DETAILS_CONFIRM:
                console.log(`Pushing to ${VERIFY_DETAILS_CONFIRM}`);
                dispatch(setCaptchaHeader(null));
                history.push({
                    pathname: VERIFY_DETAILS_CONFIRM,
                    state: {
                        stagePaymentId: beneDetails.stagePaymentId,
                    },
                });
                break;
            case ACKNOWLEDGEMENT:
                console.log(`Pushing to ${ACKNOWLEDGEMENT}`);
                dispatch(setCaptchaHeader(null));
                history.push({
                    pathname: ACKNOWLEDGEMENT,
                    state: {
                        stagePaymentId: beneDetails.stagePaymentId,
                    },
                });
                break;
            case REGISTRATION_STEP_2:
                console.log(`Pushing to ${REGISTRATION_STEP_2}`);
                dispatch(setCaptchaHeader(null));
                history.push({
                    pathname: REGISTRATION_STEP_2,
                    state: {
                        allDetails: beneDetails.registrationDetails.secDetails,
                        newPassword: beneDetails.registrationDetails.password,
                        confirmPassword: beneDetails.registrationDetails.confirmedPassword,
                        futureDetails: beneDetails.registrationDetails.saveDetails,
                        autoPayCb: beneDetails.registrationDetails.autopay,
                    },
                });
                break;
            default:
                console.log(`Default case, Pushing to ${previousPath}`);
                dispatch(setCaptchaHeader(null));
                history.push(previousPath);
        }
    };

    const [errorFlags, setErrorFlags] = useState({
        emailId: false,
        name: false,
        contactReason: false,
        descriptionOfEnquiry: false,
        captcha: false,
    });

    const [errorMessages, setErrorMessages] = useState({
        emailId: '',
        name: '',
        contactReason: '',
        descriptionOfEnquiry: '',
        captcha: '',
    });

    const [contactState, setContactState] = useState({
        emailId: globalState.beneDetails?.details?.isLogged ? globalState.beneDetails.details.emailId : '',
        name: '',
        contactReason: { label: '', value: '' },
        contactReasonsList: [],
        descriptionOfEnquiry: '',
    });

    useEffect(() => {
        if (contactState.contactReason.value) {
            console.log('Calling validate because vcalue chabnges');
            validateContactReason();
        }
    }, [contactState.contactReason.value]);

    useEffect(() => console.log('Logging contactState :', contactState), [contactState]);
    useEffect(() => console.log('Error flags are:', errorFlags), [errorFlags]);

    const CONTACT_REASONS = process.env.REACT_APP_CONTACT_REASONS;
    useEffect(() => {
        const fetchReasons = async () => {
            try {
                console.log(`Calling ${CONTACT_REASONS}`);

                const response = await axiosInstance.get(CONTACT_REASONS);
                if (response.status === 200) {
                    console.log(`Logging ${CONTACT_REASONS} response`, response.data);
                    let contactReasonsList = response.data.map((reason) => {
                        let contactReason = {
                            reason: reason.reason,
                        };
                        return contactReason;
                    });
                    setContactState({ ...contactState, contactReasonsList: contactReasonsList });
                }
            } catch (error) {
                console.error(`Logging ${CONTACT_REASONS} error`, error.response);
            }
        };
        fetchReasons();
    }, []);

    const handleReasonSelect = (SelectedOption, event) => {
        console.log('Setting contact reason as ', SelectedOption);
        setContactState({ ...contactState, contactReason: SelectedOption });
    };

    const reset = () => {
        dispatch(setCaptchaHeader(null));
        setCaptcha(null);
        setCaptchaValidationError(true);

        console.log('Removing error flags');
        setErrorFlags({
            emailId: false,
            name: false,
            contactReason: false,
            descriptionOfEnquiry: false,
            captcha: false,
        });

        console.log('Removing error messages');
        setErrorMessages({
            emailId: '',
            name: '',
            contactReason: '',
            descriptionOfEnquiry: '',
            captcha: '',
        });

        console.log('Removing contactState values');
        setContactState({
            ...contactState,
            emailId: globalState.beneDetails?.details?.isLogged ? globalState.beneDetails.details.emailId : '',
            name: '',
            contactReason: { value: '', label: '' },
            descriptionOfEnquiry: '',
        });

        setUserCaptcha('');
    };

    const validateEmail = () => {
        console.log('Validating email address');

        if (contactState.emailId.trim() === '' || contactState.emailId === null) {
            setErrorFlags({ ...errorFlags, emailId: true });
            setErrorMessages({ ...errorMessages, emailId: t('contactUs.emailAddressCannotBeEmpty') });
            return false;
        } else {
            if (isEmailValid(contactState.emailId)) {
                setErrorFlags({ ...errorFlags, emailId: false });
                setErrorMessages({ ...errorMessages, emailId: '' });
                return true;
            } else {
                setErrorFlags({ ...errorFlags, emailId: true });
                setErrorMessages({ ...errorMessages, emailId: t('contactUs.pleaseEnterAValidEmailAddress') });
                return false;
            }
        }
    };

    const validateName = () => {
        console.log('Validating name');
        if (contactState.name === '' || contactState.name === null) {
            setErrorFlags({ ...errorFlags, name: true });
            setErrorMessages({ ...errorMessages, name: t('contactUs.nameCannotBeEmpty') });
            return false;
        } else {
            setErrorFlags({ ...errorFlags, name: false });
            setErrorMessages({ ...errorMessages, name: '' });
            return true;
        }
    };

    const validateDescriptionOfEnquiry = () => {
        console.log('Validating description');
        if (contactState.descriptionOfEnquiry === '' || contactState.descriptionOfEnquiry === null) {
            setErrorFlags({ ...errorFlags, descriptionOfEnquiry: true });
            setErrorMessages({ ...errorMessages, descriptionOfEnquiry: t('contactUs.descriptionCannotBeEmpty') });
            return false;
        } else {
            setErrorFlags({ ...errorFlags, descriptionOfEnquiry: false });
            setErrorMessages({ ...errorMessages, descriptionOfEnquiry: '' });
            return true;
        }
    };

    const validateCaptchaIsCorrect = () => {
        console.log('Validating captcha');
        if (userCaptcha === '' || userCaptcha === null) {
            setErrorFlags({ ...errorFlags, captcha: true });
            setErrorMessages({ ...errorMessages, captcha: t('contactUs.captchaCannotBeEmpty') });
            return false;
        } else {
            setErrorFlags({ ...errorFlags, captcha: false });
            setErrorMessages({ ...errorMessages, captcha: '' });
            return false;
        }
    };

    const validateContactReason = () => {
        console.log('Validating reason');
        if (
            contactState.contactReason.label === undefined ||
            contactState.contactReason.label === '' ||
            contactState.contactReason.label === null ||
            contactState.contactReason.value === null ||
            contactState.contactReason.value === ''
        ) {
            setErrorFlags({ ...errorFlags, contactReason: true });
            setErrorMessages({ ...errorMessages, contactReason: t('contactUs.pleaseSelectContactReason') });
            return false;
        } else {
            setErrorFlags({ ...errorFlags, contactReason: false });
            setErrorMessages({ ...errorMessages, contactReason: '' });
            return true;
        }
    };

    const validateEverything = () => {
        let areDetailsValid = true;

        let errorFlags = {
            emailId: false,
            contactReason: false,
            descriptionOfEnquiry: false,
            captcha: false,
        };

        let errorMessages = {
            emailId: '',
            contactReason: '',
            descriptionOfEnquiry: '',
            captcha: '',
        };

        // validate email
        if (contactState.emailId.trim() === '' || contactState.emailId === null) {
            errorFlags.emailId = true;
            errorMessages.emailId = t('contactUs.emailAddressCannotBeEmpty');
            areDetailsValid = false;
        } else {
            if (isEmailValid(contactState.emailId)) {
                errorFlags.emailId = false;
                errorMessages.emailId = '';
            } else {
                errorFlags.emailId = true;
                errorMessages.emailId = t('contactUs.pleaseEnterAValidEmailAddress');
                areDetailsValid = false;
            }
        }


        console.log('Validating reason');
        // Validating contact reason
        if (contactState.contactReason.label === undefined || contactState.contactReason.label === '' || contactState.contactReason.label === null) {
            errorFlags.contactReason = true;
            errorMessages.contactReason = t('contactUs.pleaseSelectContactReason');
            areDetailsValid = false;
        } else {
            errorFlags.contactReason = false;
            errorMessages.contactReason = '';
        }

        // Validate description
        console.log('Validating description on submit click');
        if (contactState.descriptionOfEnquiry === '' || contactState.descriptionOfEnquiry === null) {
            errorFlags.descriptionOfEnquiry = true;
            errorMessages.descriptionOfEnquiry = t('contactUs.descriptionCannotBeEmpty');
            areDetailsValid = false;
        } else {
            errorFlags.descriptionOfEnquiry = false;
            errorMessages.descriptionOfEnquiry = '';
        }

        if (CAPTCHA_ENABLED) {
            if (captcha) {
                console.log('Captcha was validated');
                errorFlags.captcha = false;
                errorMessages.captcha = '';
            } else {
                console.log('Error validating captcha');

                errorFlags.captcha = true;
                errorMessages.captcha = 'Please verify captcha';

                areDetailsValid = false;
            }
        }

        console.log('Setting error messages in state');
        setErrorMessages({
            emailId: errorMessages.emailId,
            name: errorMessages.name,
            contactReason: errorMessages.contactReason,
            descriptionOfEnquiry: errorMessages.descriptionOfEnquiry,
            captcha: errorMessages.captcha,
        });

        console.log('Setting error flags in state');
        setErrorFlags({
            emailId: errorFlags.emailId,
            name: errorFlags.name,
            contactReason: errorFlags.contactReason,
            descriptionOfEnquiry: errorFlags.descriptionOfEnquiry,
            captcha: errorFlags.captcha,
        });

        return areDetailsValid;
    };

    const callSubmit = async () => {
        let areDetailsValid = validateEverything();
        if (areDetailsValid) {
            try {
                let requestBody = JSON.stringify({
                    emailId: contactState.emailId,
                    reason: contactState.contactReason.label,
                    description: contactState.descriptionOfEnquiry,
                    captca: userCaptcha,
                });
                const response = await axiosInstance.post(SUBMIT_CONTACT_US, requestBody);
                if (response.status === 200) {
                    console.log(`Logging ${SUBMIT_CONTACT_US} success`, response.data);
                    setOpen(true);
                }
            } catch (error) {
                console.error(`Logging ${SUBMIT_CONTACT_US} error`, error.response);
                setCaptcha(null);
                console.log('Clearing token due to error');
                dispatch(setCaptchaHeader(null));
                if (error && error.response.status === 400) {
                    setErrorFlags({ ...errorFlags, emailId: true });
                    setErrorMessages({ ...errorMessages, emailId: error.response.data.message });
                    setCaptchaValidationError(true);
                    console.log('Error from SEND_OTP_URL', error);
                }
            }
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);
            return;
        }
    };

    return (
        <StyledDiv style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                <Typography variant='h1' className='page-title' tabIndex='-1'>
                    {t('contactUs.contactUs')}
                </Typography>
            </Box>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4}>
                    <Box marginTop={['5px', '5px', '5px', '24px']} display='flex' flexDirection='row-reverse'>
                        <Typography variant='body1'>{t('paymentBankDetails.mandatoryFields')}</Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container>
                <Field name='cu-textbox-email'>
                    <Grid item xs={12} sm={4} md={2}>
                        <LabelBox display='flex'>
                            <Box display='inline'>
                                <FieldLabel variant='body1'>{t('contactUs.email')} </FieldLabel>
                            </Box>
                            <Box paddingLeft='0.5em' display='inline'>
                                <HoverTip content={t('contactUs.tooltipText')} ariaLabel={t('contactUs.tooltipTextinfo')} id='contactus-tooltip-email'/>
                            </Box>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextInputBox>
                            <TextInput
                                aria-describedby='cu-inline-error-email'
                                className={errorFlags.emailId ? 'hasError' : ''}
                                placeholder={t('contactUs.pleaseEnterEmail')}
                                disabled={globalState.beneDetails?.details?.isLogged}
                                value={globalState.beneDetails?.details?.isLogged ? globalState.beneDetails.details.emailId : contactState.emailId}
                                onChange={(event) => setContactState({ ...contactState, emailId: event.value })}
                                onBlur={() => {
                                    if (!globalState.beneDetails?.details?.isLogged) {
                                        validateEmail();
                                    }
                                }}
                                invalid={errorFlags.emailId}
                            />
                            {errorFlags.emailId ? (
                                <InlineNotificationComponent id='cu-inline-error-email' title='' content={errorMessages.emailId} />
                            ) : null}
                        </TextInputBox>
                    </Grid>
                </Field>
            </Grid>

            <Grid container>
                <Field name='cu-dropdown-contactReason'>
                    <Grid item xs={12} sm={4} md={2}>
                        <LabelBox>
                            <FieldLabel id='cu-dropdown-contactReason' variant='body1'>
                                {t('contactUs.contactReason')}
                            </FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextInputBox>
                            <NativeDropdown
                                aria-describedby='cu-inline-error-contactReason'
                                className={errorFlags.contactReason ? 'hasError' : ''}
                                width='100%'
                                id='cu-dropdown-contactReason-field'
                                options={
                                    contactState.contactReasonsList.length > 0
                                        ? contactState.contactReasonsList.map((reason) => {
                                              let contactReason = {
                                                  value: reason.reason,
                                                  label: reason.reason,
                                              };
                                              return contactReason;
                                          })
                                        : []
                                }
                                onChange={(SelectedOption) => {
                                    handleReasonSelect(SelectedOption);
                                }}
                                onBlur={() => {
                                    validateContactReason();
                                }}
                                value={contactState?.contactReason?.value}
                            />
                            {errorFlags.contactReason ? (
                                <InlineNotificationComponent id='cu-inline-error-contactReason' title='' content={errorMessages.contactReason} />
                            ) : null}
                        </TextInputBox>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Field name='cu-textbox-descriptionOfEnquiry'>
                    <Grid item xs={12} sm={4} md={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('contactUs.descriptionOfEnquiry')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextInputBox>
                            <Textarea
                                aria-describedby='cu-inline-error-descriptionOfEnquiry'
                                width='100%'
                                maxLength='1500'
                                value={contactState.descriptionOfEnquiry}
                                className={errorFlags.descriptionOfEnquiry ? 'hasError' : ''}
                                placeholder={t('contactUs.yourMessageHere')}
                                height={150}
                                onChange={(event) => setContactState({ ...contactState, descriptionOfEnquiry: event.target.value })}
                                onBlur={() => {
                                    validateDescriptionOfEnquiry();
                                }}
                                invalid={contactState.descriptionOfEnquiry}
                            />
                            {errorFlags.descriptionOfEnquiry ? (
                                <InlineNotificationComponent
                                    id='cu-inline-error-descriptionOfEnquiry'
                                    title=''
                                    content={errorMessages.descriptionOfEnquiry}
                                />
                            ) : null}
                        </TextInputBox>
                    </Grid>
                </Field>
            </Grid>
 
            {CAPTCHA_ENABLED ? (
                <Grid container>
                    <Field name='cu-textbox-captcha'>
                        <Grid item xs={12} sm={4} md={2}></Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <ReCaptcha
                                onVerification={(token) => {
                                    // Set header setHeaders({ 'X-HSBC-ReCaptcha-Response': token });
                                    console.log('Got a new Captcha token', token);
                                    setCaptcha(token);
                                    dispatch(setCaptchaHeader(token));
                                    setCaptchaValidationError(false);
                                }}
                                onExpiry={() => {
                                    // Happens when timed out
                                    setCaptcha(null);
                                }}
                                resetCaptcha={captchaValidationError} // Boolean variable that indicates if there was error in captcha
                                action='onVerification'
                            />
                            {errorFlags.captcha ? (
                                <InlineNotificationComponent id='cu-inline-error-captcha' title='' content={errorMessages.captcha} />
                            ) : null}
                            {/**True when error occurs */}
                        </Grid>
                    </Field>
                </Grid>
            ) : null}

            <Grid container>
                <Grid item xs={12} sm={8} md={6}>
                    <Box
                        width='100%'
                        display='flex'
                        flexDirection='row'
                        marginTop={['5px', '5px', '5px', '24px']}
                        paddingTop={['5px', '5px', '5px', '24px']}
                        borderTop='1px solid #333'
                    >
                        <Box width='50%'>
                            <Box>
                                <Button variant='light.tertiary' onClick={() => sendUserBack()} id='cu-button-cancel'>
                                    {t('contactUs.cancel')}
                                </Button>
                            </Box>
                        </Box>
                        <Box display='flex' flexDirection='row' justifyContent='flex-end' width='50%'>
                            <Box marginLeft='1em'>
                                <Button
                                    variant='light.tertiary'
                                    id='cu-button-reset'
                                    onClick={() => {
                                        console.log('Calling reset');
                                        reset();
                                    }}
                                >
                                    {t('contactUs.reset')}
                                </Button>
                            </Box>

                            <Box marginLeft='1em'>
                                <Button
                                    variant='light.primary'
                                    onClick={() => {
                                        callSubmit();
                                    }}
                                    id='cu-button-submit'
                                >
                                    {t('contactUs.submit')}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
                <LabelBox>
                    <Typography variant='body1'>
                        <b>NOTE: </b>
                        {t('contactUs.note')}
                    </Typography>
                </LabelBox>
            </Grid>

            <Modal
                open={open}
                onHide={() => {
                    setOpen(false);
                }}
                closeIcon={true}
                onClickCloseIcon={() => {
                    setOpen(false);
                }}
                size='small'
                activeFocusTrap={true}
                aria-labelledby='title1'
                minHeight='230px'
            >
                <Box display='flex' justifyContent='center' width='100%' marginTop='10%'>
                    <Box>
                        <Typography variant='h4' id='paymentsList-typo-modal-text' fontWeight='bold'>
                            {modalText}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    position='absolute'
                    bottom='0'
                    py='1em'
                    width='calc(100% - 80px)'
                    display='flex'
                    justifyContent='center'
                    borderTop='1px solid #333'
                >
                    <Button
                        variant='light.primary'
                        onClick={() => {
                            setOpen(false);
                            sendUserBack();
                        }}
                    >
                        OK
                    </Button>
                </Box>
            </Modal>
        </StyledDiv>
    );
};

export default ContactUs;
